import * as React from "react"
import { cn } from "../../lib/utils"

const DropdownMenu = ({ children, open, onClose, anchorEl }) => {
  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div 
        className={cn(
          "absolute right-0 mt-2 w-60 rounded-md border bg-popover p-1 text-popover-foreground shadow-md z-50",
          "animate-in fade-in-0 zoom-in-95"
        )}
      >
        {children}
      </div>
    </>
  );
};

const DropdownMenuItem = React.forwardRef(({ className, children, onClick, ...props }, ref) => (
  <button
    ref={ref}
    className={cn(
      "relative flex w-full cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors",
      "hover:bg-accent hover:text-accent-foreground",
      "focus:bg-accent focus:text-accent-foreground",
      className
    )}
    onClick={onClick}
    {...props}
  >
    {children}
  </button>
));
DropdownMenuItem.displayName = "DropdownMenuItem";

const DropdownMenuSeparator = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("-mx-1 my-1 h-px bg-border", className)}
    {...props}
  />
));
DropdownMenuSeparator.displayName = "DropdownMenuSeparator";

export { DropdownMenu, DropdownMenuItem, DropdownMenuSeparator };
